import { UserRole } from '@klubovna/api-client';

export const ConsoleRoutePath = {
  Login: 'login',
  Admin: 'admin',
  Pos: 'pos',
  Volunteer: 'volunteer',
  ChangePassword: 'change-password',
  MemberUnavailable: 'member',
} as const;

export type ConsoleRoutePath = (typeof ConsoleRoutePath)[keyof typeof ConsoleRoutePath];

export const ConsoleRoute = {
  Login: `/${ ConsoleRoutePath.Login }`,
  Admin: `/${ ConsoleRoutePath.Admin }`,
  Pos: `/${ ConsoleRoutePath.Pos }`,
  Volunteer: `/${ ConsoleRoutePath.Volunteer }`,
  ChangePassword: `/${ ConsoleRoutePath.ChangePassword }`,
  MemberUnavailable: `/${ ConsoleRoutePath.MemberUnavailable }`,
} as const;

export type ConsoleRoute = (typeof ConsoleRoute)[keyof typeof ConsoleRoute];

const ROLE_HOME_ROUTES: Partial<Record<UserRole, ConsoleRoute>> = {
  [UserRole.Owner]: ConsoleRoute.Admin,
  [UserRole.Admin]: ConsoleRoute.Admin,
  [UserRole.EventAdmin]: ConsoleRoute.Admin,
  [UserRole.Cashier]: ConsoleRoute.Pos,
  [UserRole.Volunteer]: ConsoleRoute.Volunteer,
};

export function homeRouteForRole(role: UserRole | undefined, additionalRoles?: readonly UserRole[] | null): ConsoleRoute {
  const homeRoutes = [ role, ...(additionalRoles ?? []) ]
    .filter((candidate): candidate is UserRole => !!candidate)
    .map(candidate => ROLE_HOME_ROUTES[candidate]);

  return homeRoutes.find((route): route is ConsoleRoute => !!route) ?? ConsoleRoute.MemberUnavailable;
}
